import React, { useEffect, useState } from 'react'
import DatePicker from "react-datepicker";

import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('ES', es)
type PropsYearDatePicker = {
    onChange: (date: any) => void,
    maxDate?: string | null,
    minDate?: string | null,
    disabled?: boolean,
    value?: number | null,
    blueStyle?: boolean,
}



export default function YearDatePicker(props: PropsYearDatePicker) {

    const stylesYear: React.CSSProperties = {
        backgroundColor: "#FFFFFF",
        border: "1px solid #517ED3",
        borderRadius: "5px",
    }

    const [startDate, setstartDate] = useState<Date>()

    useEffect(() => {
        if (props.value) {
            const fecha = new Date(props.value, 0, 1)
            setstartDate(fecha)
        }
    }, [props.value])




    function HandleChange(date) {

        props.onChange(date);
        setstartDate(date)
    }

    const disableDatePicker: boolean = props.disabled !== undefined && props.disabled === true

    return (
        <DatePicker
            selected={startDate}
            onChange={(date) => HandleChange(date)}
            dateFormat="yyyy"
            showYearPicker
            locale="ES"
            maxDate={props.maxDate ? new Date(props.maxDate) : null}
            minDate={props.minDate ? new Date(props.minDate) : null}
            utcOffset={"America/Guayaquil"}
            disabled={disableDatePicker}
            customInput={props.blueStyle ? <input style={stylesYear}></input>: undefined}
        />
    )
}
